"use client";

import { c as _c } from "react/compiler-runtime";
import Cookies from "js-cookie";
import type { ReactNode } from "react";
import { clientEnv } from "@/lib/env.client";
import { AuthenticatedLaunchDarklyContextReadyProvider, LaunchDarklyProvider } from "./LaunchDarklyProvider";
interface LaunchDarklyClientWrapperProps {
  children: ReactNode;
}

/**
 * Client-side LaunchDarkly wrapper for use in client components.
 *
 * Unlike the server-side LaunchDarklyWrapper (which reads cookies/session via
 * next/headers), this initializes with a temporary context from the client-side
 * cookie. LaunchDarklyContextUpdater will update the context with real user data
 * once the authenticated providers are ready.
 */
export function LaunchDarklyClientWrapper(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = clientEnv();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const clientSideID = t1.NEXT_PUBLIC_LAUNCHDARKLY_CLIENT_ID;
  if (!clientSideID) {
    let t2;
    if ($[1] !== children) {
      t2 = <>{children}</>;
      $[1] = children;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = Cookies.get("ld_anonymous_key");
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const existingAnonymousKey = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      kind: "multi" as const,
      user: {
        key: existingAnonymousKey || "anonymous-temp",
        anonymous: true
      }
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const context = t3;
  let t4;
  if ($[5] !== children) {
    t4 = <AuthenticatedLaunchDarklyContextReadyProvider><LaunchDarklyProvider clientSideID={clientSideID} context={context}>{children}</LaunchDarklyProvider></AuthenticatedLaunchDarklyContextReadyProvider>;
    $[5] = children;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}